import styled from 'styled-components';

export const NameYouAlsoLikeCont = styled.div`
  margin: 20px 0 50px;

  @media (max-width: 720px) {
    margin: 20px 0 40px;
  }
`;

export const AddedToast = styled.div`
  background: #000;
  opacity: 0.8;
  padding: 0 8px;
  display: flex;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 99;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  bottom: 20px;
  width: 100%;
  max-width: 330px;
  margin: 0 auto;
  left: 0;
  right: 0;
  border-radius: 4px;

  & p {
    padding-left: 6px;
    font-weight: 400;
  }
`;
export const SaveToast = styled.div`
  background: #000;
  opacity: 0.8;
  padding: 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 99;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  bottom: 20px;
  max-width: 330px;
  margin: 0 auto;
  left: 0;
  right: 0;
  border-radius: 4px;

  & p {
    font-weight: 400;
  }
`;

export const InstallBanner = styled.img`
  width: 100%;
  height: auto;
`;
export const Header1 = styled.div`
  cursor: pointer;
  @media (max-width: 720px) {
    // display: none;
    cursor: none;
  }
`;
export const Header2 = styled.div`
  @media (min-width: 720px) {
    display: none;
  }
`;

export const RelatedNames = styled.h2`
  font-size: clamp(13px, 2vw, 16px);
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 50%);
  padding: 10px 0 10px 20px;
  height: 38px;
  @media (min-width: 720px) {
    text-transform: uppercase;
  }
  .english_link {
    text-decoration: underline;
    color: rgb(31, 31, 255);
  }
  .lowOpacity {
    opacity: 0.5;
  }
`;
